export default __webpack_public_path__ + "d4886d2aaf54fdc3b337bffa493429f1.png";